import UnloadingAudio, { UnloadingAudioProps } from './UnloadingAudio';

export default UnloadingAudio;
export type { UnloadingAudioProps };
